var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.63 6.368c1.723.494 3.076 1.944 3.537 3.788h-.003C40 13.497 40 20.473 40 20.473s0 6.974-.836 10.315c-.461 1.845-1.815 3.295-3.537 3.789-3.118.896-15.627.896-15.627.896s-12.51 0-15.627-.896c-1.722-.494-3.076-1.944-3.537-3.79C0 27.447 0 20.473 0 20.473s0-6.975.836-10.316c.461-1.844 1.815-3.294 3.537-3.788C7.49 5.472 20 5.472 20 5.472s12.51 0 15.63.896zm-9.236 14.104L16 14.044V26.9l10.396-6.427z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bcd8106fc1f4264ffef1d7fe423f14ee.svg";
export { ForwardRef as ReactComponent };